<template>
     <b-navbar class="topnav-border">
        <!--Branding | Logo-->
        <template slot="brand">
            <b-navbar-item href="/staff" >
                <img
                    src="../../../assets/logo.png"
                >
                
            </b-navbar-item>
        </template>

        <!--Buttons | Dropdowns to the bottom -->
        <template slot="end">
            
            <SitesDropdown
            v-if="currentSite != mainDomain"
            :company-name="companyName"
            :company-id="companyId"
            :companies-endpoint="companiesEndpoint"/>

            <b-navbar-dropdown>
            <template slot="label">
                <b-icon class="m-r-10" pack="fas" size="is-small" icon="user-cog"></b-icon>
                {{userName}}
            </template>
                <b-navbar-item href="/">
                    Profile Details
                </b-navbar-item>
                <b-navbar-item href="/user/logout">
                    Logout
                </b-navbar-item>
            
            </b-navbar-dropdown>
            
        </template>
    </b-navbar>
</template>


<script>
import SitesDropdown from './components/SitesDropdown.vue'

export default {
  name: 'Navbar',
  
  props:{
      companyName:{
          type: String,
          default: ""
      },
      companyId:{
          type:String,
          default: ""
      },
      userName: {
          type:String,
          default:""
      },
      mainDomain: {
        type:String,
        default:""
      },
      currentSite: {
        type:String,
        default:""
      },
      companiesEndpoint: {
        type:String,
        default:""
      }
  },

  components: {
    SitesDropdown
  },



}
</script>

<style lang="scss" scoped>
  @import "./../../../scss/main.scss";

  .topnav-border{
        border-bottom: 5px solid $primary;
        box-shadow: $primary-shadow-light 0px 0px 8px 4px;
  }
</style>
